import { createAction, props } from '@ngrx/store';
import { Order } from '../../models/Order';
import { GatewayOrder } from '../../models/GatewayOrder';

export const getReflexOrders = createAction(
  '[Order] Get Reflex Orders',
  props<{
    filters?: {
      fromDate?: string;
      toDate?: string;
      status?: string;
      page?: number;
      pageSize?: number;
    };
  }>()
);

export const getReflexOrdersSuccess = createAction(
  '[Order] Get Reflex Orders Success',
  props<{ orders: GatewayOrder[] }>()
);

export const getOrdersByMe = createAction('[Order] Get Orders By Me');
export const getOrdersByMeSuccess = createAction(
  '[Order] Get Orders By Me Success',
  props<{ orders: Order[] }>()
);

export const getOrdersByCustomerId = createAction(
  '[Order] Get Orders By Customer Id',
  props<{ customerId: number }>()
);
export const getOrdersByCustomerIdSuccess = createAction(
  '[Order] Get Orders By Customer Id Success',
  props<{ orders: Order[] }>()
);

export const getPendingOrders = createAction('[Order] Get Pending Orders');
export const getPendingOrdersSuccess = createAction(
  '[Order] Get Pending Orders Success',
  props<{ orders: Order[] }>()
);

export const getReflexOrderById = createAction(
  '[Order] Get Reflex Order By Id',
  props<{ id: string }>()
);
export const getReflexOrderByIdSuccess = createAction(
  '[Order] Get Reflex Order By Id Success',
  props<{ order: GatewayOrder }>()
);

export const setSelectedOrder = createAction(
  '[Order] Set Selected Order',
  props<{ id: string }>()
);
export const setSelectedOrderSuccess = createAction(
  '[Order] Set Selected Order Success',
  props<{ order: Order }>()
);
export const setSelectedOrderFailure = createAction(
  '[Order] Set Selected Order Failure'
);

export const clearSelectedOrder = createAction('[Order] Clear Selected Order');

export const useCoins = createAction(
  '[Order] Use Coins',
  props<{ userName: string; reflexId: string; coins: number }>()
);
export const useCoinsSuccess = createAction(
  '[Order] Use Coins Success',
  props<{ order: Order }>()
);
export const useCoinsFailure = createAction(
  '[Order] Use Coins Failure',
  props<{ error: unknown }>()
);

export const changeOrderStatus = createAction(
  '[Order] Change Order Status',
  props<{ orderId: number; action: 'approve' | 'decline' }>()
);
export const changeOrderStatusSuccess = createAction(
  '[Order] Change Order Status Success',
  props<{ order: Order }>()
);
